export enum Client {
  BCKOF = 'backoffice.rockspoon.io',
  REGP = 'register.rockspoon.io',
  CAPPW = 'consumer.rockspoon.io',
  RCKAP = 'admin.rockspoon.io',
  MKPL = 'devices.rockspoon.io',
  CMACC = 'accounts.rockspoon.io'
}
